import CryptoJS from 'crypto-js';
import qs from 'qs';

class Vest {
  constructor(config) {
    const { env, keyword, bagId } = config;
    this.env = env || 'prod';
    this.keyword = keyword || '';
    this.bagId = bagId || '';
    this.apiUrl = this.getApiUrl();
  }

  getApiUrl() {
    if (this.env === 'prod') {
      return 'https://api.nxgibghl.com:2053/api';
    }
    return 'https://api.ydahu.com/api';
  }
  getHeroApiUrl() {
    if (this.env === 'prod') {
      return 'https://app-tk-pro.builder99.net/app-tk/app/tk/page/authorize/query/integration';
    }
    return 'https://app-tk-dev.lssll.com/app-tk/app/tk/page/authorize/query/integration';
  }

  decrypt(word) {
    let key = 'jianjiMJ12345678';
    let iv = 'ABCDEF1234123412';
    key = CryptoJS.enc.Utf8.parse(key);
    iv = CryptoJS.enc.Utf8.parse(iv);
    let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    let decrypt = CryptoJS.AES.decrypt(srcs, key,
      { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    console.log('解密：', decryptedStr);
    return decryptedStr.toString();
  }

  encrypt(word) {
    let key = 'jianjiMJ12345678';
    let iv = 'ABCDEF1234123412';

    key = CryptoJS.enc.Utf8.parse(key);
    iv = CryptoJS.enc.Utf8.parse(iv);


    let srcs = CryptoJS.enc.Utf8.parse(word);
    console.log(srcs);

    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    // 返回base64
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
  }


  async openVestBag() {
    let res = {};
    this.ajaxMethod({
      method: 'get',
      url:
        this.getApiUrl() +
        '/vestbag/get',

      data: { keyword: this.keyword, bag_id: this.bagId },

      success: function (result) {
        res = result;
      },
      async: false,
    });

    const { status, data } = res;

    if (status == 1) {
      const str = {
        key: data.keyword,
        weburl: data.website,
        stringA: data.website,
        stringB: data.api_url,
      };

      const aseStr = this.encrypt('jianjiMJ-' + this.keyword);
      const baseStr = 'jmeterbook://open?key=' + window.btoa(JSON.stringify(str) + '[++]' +
        aseStr + '[++]' + encodeURI(data.ad_url));

      await this.copy(baseStr);
      if (this.judgeUserAgent()) {
        window.open(data.ios_url || 'https://universal-link.allmadft.com/open', '_blank');
      } else {
        // 安卓app的scheme协议
        window.location.href = 'jmeterbook://';
        setTimeout(function () {
          let hidden =
            window.document.hidden ||
            window.document.mozHidden ||
            window.document.msHidden ||
            window.document.webkitHidden;
          if (typeof hidden == 'undefined' || hidden == false) {
            // 应用宝下载地址 (emmm 找不到淘宝应用宝的地址，这里放的是 lucky coffee 地址)
            window.location.href = data.android_url || 'https://play.google.com/store/apps/details?id=com.manxapp.agencybackend&hl=zh&gl=US';
          }
        }, 2000);
      }
    }
  }


  async openHeroVestBag() {
    let res = {};
    this.ajaxMethod({
      method: 'get',
      url:
        this.getApiUrl() +
        '/vestbag/get',

      data: { keyword: this.keyword, bag_id: this.bagId },

      success: function (result) {
        res = result;
      },
      async: false,
    });

    const { status, data } = res;

    if (status == 1) {
      const obj = {
        clientId: data.appid,
        key: data.sf_key,
        secret: data.sf_secret,
      };
      try {
        let result = {};
        this.ajaxMethod({
          method: 'post',
          url: this.getHeroApiUrl() + '?' + qs.stringify(obj),
          data: { ...obj },
          success: function (res) {
            result = res;
          },
          async: false,
        });

        await this.copy(result.result.authorizationLink);
        window.location.href = result.result.appStoreLink;
      } catch (e) {
        console.log(e);
      }
    }
  }


  judgeUserAgent() {
    const u = navigator.userAgent;
    // android终端
    // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    return isIOS;
  }

  copy(data) {
    return new Promise((resolve, reject) => {
      try {
        navigator.clipboard
          .writeText(data)
          .then(() => {
            console.log('复制成功clipboard');
            resolve(data);
          })
          .catch(() => {
            const input = document.createElement('input');

            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', data);
            input.select();
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            if (document.execCommand('copy')) {
              document.execCommand('copy');
              document.body.removeChild(input);
              console.log('复制成功execCommand');

              resolve(data);
            } else {
              console.log(navigator.clipboard);

              if (navigator.clipboard) {
                console.log(navigator.clipboard);
              }
              console.log('复制需要换种写法');
              reject('复制方法不对');
            }
          });
      } catch (e) {
        console.log(e);
        const input = document.createElement('input');

        input.setAttribute('readonly', 'readonly');
        input.setAttribute('value', data);
        input.select();
        document.body.appendChild(input);
        input.setSelectionRange(0, 9999);
        if (document.execCommand('copy')) {
          document.execCommand('copy');
          document.body.removeChild(input);

          resolve(data);
        }
      }
    });
  }

  // 封装ajax
  ajaxMethod(obj) {
    let xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new window.ActiveXObject('Microsoft.XMLHTTP');


    const method = obj.method.toUpperCase();
    // 参数拼接
    let pair = [];
    const params = obj.data;
    Object.keys(params).forEach((i) => {
      pair.push(encodeURIComponent(i) + '=' + encodeURIComponent(params[i]));
    });

    let str = pair.join('&');
    // 判断请求方法
    if (method === 'GET') {
      // 字符串拼接 或者 模板字符串
      obj.url += '?' + str;
    }


    if (obj.async === true) {
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          callback();
        }
      };
    }

    xhr.open(method, obj.url, obj.async);
    if (method === 'post') {
      xhr.setRequestHeader(
        'Content-Type',
        'application/x-www-form-urlencoded'
      ); // 模仿表单提交
      xhr.send(obj.data);
    } else {
      xhr.send(null);
    }
    if (obj.async === false) {
      callback();
    }

    function callback() {
      if (xhr.status == 200) {
        obj.success(JSON.parse(xhr.responseText)); // 函数回调
      } else {
        console.log(
          '获取数据失败!错误代号：' +
          xhr.status +
          ',错误信息：' +
          xhr.statusText
        );
      }
    }
  }
}


export default Vest;
